import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/hourglass': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M368 48c0 80.1-31.9 165.6-97.2 208 65 42.2 97.2 127.4 97.2 208h4c6.6 0 12 5.4 12 12v24c0 6.6-5.4 12-12 12h-360c-6.6 0-12-5.4-12-12v-24c0-6.6 5.4-12 12-12h4c0-80.1 31.9-165.6 97.2-208-65-42.2-97.2-127.4-97.2-208h-4c-6.6 0-12-5.4-12-12v-24c0-6.6 5.4-12 12-12h360c6.6 0 12 5.4 12 12v24c0 6.6-5.4 12-12 12h-4zM64 48c0 101.6 57.3 184 128 184s128-82.4 128-184h-256zM320 464c0-101.6-57.3-184-128-184s-128 82.4-128 184h256z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/hourglass.js
// module id = 1778
// module chunks = 0